import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../../../axiosinterceptor';

const initialState = {
  auditorPage: false,
  status: {
    statusChangeLoading: false,
    statusChangeMessage: "",
    statusChangeError: null,
  },
  auditorViewEpisodesPayload: {
    separation_date_from: null,
    separation_date_to: null,
    speciality: [],
    queue: [],
    queue_priority: [],
    status: [],
    queue_page_number: 1,
    page_number: 1,
    search_term: "",
    ur_number: []
  },
  auditorViewStats: {
  auditorViewStatsLoading: false,
  auditorViewStatsData: {},
  auditorViewStatsError: null,
  },
  getQueuesData: {
    queuesData: [],
    queuesLoading: false,
    queuesError: null
  },
  auditorViewResponse: {
    auditorViewData: [],
    auditorViewDataLoading: false,
    auditorViewDataError: null,
  },
  auditorViewFilters: {
    auditorViewFilterOptionsLoading: false,
    auditorViewFilterOptionsError: null,
    auditorViewFiltersPriority: [],
    auditorViewFiltersStatus: [],
  },
  speciality: {
    specialityPageNumber: 0,
    specialityData: [],
    specialityLoading: false,
    specialityError: null,
    isSpecialityPageTrue: true
  },
  episodesURnumber: {
    episodesURnumberPageNumber: 0,
    episodesURnumberData: [],
    episodesURnumberLoading: false,
    episodesURnumberError: null,
    isEpisodesURnumberPageTrue: true
  },
  queue: {
    queuePageNumber: 0,
    queueData: [],
    queueLoading: false,
    queueError: null,
    isQueuePageTrue: true
  },
};

export const getAuditorViewData = createAsyncThunk(
  '/getAuditorViewData',
  async(payload, {fulfillWithValue, rejectWithValue}) => {
    try{
      const response = await axiosInstance.post('/Audited_screen_workflow_get_dashboard_data', payload);
      if(response.data) {
       return fulfillWithValue(response.data)
      }
      // return data; 
    }
    catch(error) {
      console.error('Error fetching episodes:', error);
      return rejectWithValue(error.response?.data?.message || error.message || "No data found");
      // throw error;
    }
  }
)

export const getAllQueuesData = createAsyncThunk(
  '/getAllQueuesData',
  async(payload, {fulfillWithValue, rejectWithValue}) => {
    try{
      const response = await axiosInstance.post('/Audit_screen_get_queue_data', payload);
      if(response.data) {
       return fulfillWithValue(response?.data)
      }
      // return data; 
    }
    catch(error) {
      console.error('Error fetching episodes:', error);
      return rejectWithValue(error.response?.data?.message || error.message || "No data found");
      // throw error;
    }
  }
)


export const changeStatus = createAsyncThunk(
  '/changeStatus',
  async(payload, {fulfillWithValue, rejectWithValue}) => {
    const requiredPaylaod = {...payload};
    delete requiredPaylaod.auditorPage;
    // console.log(requiredPaylaod, 'requiredPaylaod')
    const url = payload?.auditorPage ?  "/auditor_screen_status_change" : "/coding_screen_status_update_"
    try{
      const response = await axiosInstance.post(url, requiredPaylaod);
      if(response.data) {
       return fulfillWithValue(response.data)
      }
      // return data; 
    }
    catch(error) {
      console.error('something went wrong :', error);
      return rejectWithValue(error.response?.data?.message || error.message || "something went wrong");
      // throw error;
    }
  }
)

export const getAuditorViewStatsData = createAsyncThunk(
  '/getAuditorViewStatsData',
  async(payload, {fulfillWithValue, rejectWithValue}) => {
    try{
      const response = await axiosInstance.post('/stats_audit_screen_workflow', payload);
      if(response.data) {
       return fulfillWithValue(response.data)
      }
      // return data; 
    }
    catch(error) {
      console.error('Error fetching stats:', error);
      return rejectWithValue(error.response?.data?.message || error.message || "No data found");
      // throw error;
    }
  }
)

export const getauditorViewFilterOptions = createAsyncThunk(
  '/getauditorViewFilterOptions',
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/workflow_audit_screen_get_filters_status_priority_data");
      return fulfillWithValue(response.data);
    } catch (error) {
      console.error('Error fetching filter options:', error);
      // return rejectWithValue(error.response?.data?.message || error.message || "No data found");
    }
  }
);

export const specialityOptions = createAsyncThunk(
  '/specialityOptions',
  async (pageNumber, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/workflow_audit_screen_get_filters_speciality_data?page_number=${pageNumber}`);
      return fulfillWithValue(response.data); // Make sure to return the payload
    } catch (error) {
      console.error('Error fetching filter options:', error);
      // return rejectWithValue(error.response?.data?.message || error.message || "No data found");
    }
  }
);

export const queueOptions = createAsyncThunk(
  '/queueOptions',
  async (pageNumber, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/workflow_audit_screen_get_filters_queue_data?page_number=${pageNumber}`);
      return fulfillWithValue(response.data); // Make sure to return the payload
    } catch (error) {
      console.error('Error fetching filter options:', error);
      // return rejectWithValue(error.response?.data?.message || error.message || "No data found");
    }
  }
);

export const URnumberOptions = createAsyncThunk(
  '/URnumberOptions',
  async (pageNumber, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/workflow_audit_screen_get_filters_urnumber_data?page_number=${pageNumber}`);
      return fulfillWithValue(response.data); // Make sure to return the payload
    } catch (error) {
      console.error('Error fetching filter options:', error);
      // return rejectWithValue(error.response?.data?.message || error.message || "No data found");
    }
  }
);


const auditorViewSlicer = createSlice({
  name: "auditorView",
  initialState,
  reducers: {
    updateComponentState:(state, action) => {
      state.auditorViewComponentState.selectedRecord = action.payload
    },
    updateFilters: (state, action) => {
      state.auditorViewEpisodesPayload = {
        ...state.auditorViewEpisodesPayload,
        ...action.payload,
      };
    },
    updateAuditorPageNumber: (state, action) => {
      state.auditorViewEpisodesPayload.page_number = action.payload
    },
    updateAuditorPage: (state, action) => {
      state.auditorPage = action.payload
    },
    updateSpecialityPageNumber: (state, action) => {
      state.speciality.specialityPageNumber = action.payload
    },
    updateQueuePageNumber : (state, action) => {
      state.queue.queuePageNumber = action.payload
    },
    updateUserPageNumber : (state, action) => {
      state.episodesURnumber.episodesURnumberPageNumber = action.payload
    },
  },
  extraReducers: (builder) => builder
  .addCase(getAuditorViewData.pending, (state) => {
    state.auditorViewResponse.auditorViewDataLoading = true;
    state.auditorViewResponse.auditorViewDataError = null;
  }).addCase(getAuditorViewData.fulfilled, (state,action) => {
    state.auditorViewResponse.auditorViewDataLoading= false;
    state.auditorViewResponse.auditorViewData = action.payload;
  }).addCase(getAuditorViewData.rejected, (state, action) => {
    state.auditorViewResponse.auditorViewDataLoading = false;
    state.auditorViewResponse.auditorViewDataError = action.payload;
  })
   .addCase(getAuditorViewStatsData.pending, (state) => {
    state.auditorViewStats.auditorViewStatsLoading = true;
    state.auditorViewStats.auditorViewStatsError = null;
  }).addCase(getAuditorViewStatsData.fulfilled, (state,action) => {
    state.auditorViewStats.auditorViewStatsLoading= false;
    state.auditorViewStats.auditorViewStatsData = action.payload;
  }).addCase(getAuditorViewStatsData.rejected, (state, action) => {
    state.auditorViewStats.auditorViewStatsLoading = false;
    state.auditorViewStats.auditorViewStatsError = action.payload;
  })
  .addCase(getauditorViewFilterOptions.pending, (state) => {
    state.auditorViewFilters.auditorViewFilterOptionsLoading = true;
    state.auditorViewFilters.auditorViewFilterOptionsError = null;
  }).addCase(getauditorViewFilterOptions.fulfilled, (state, action) => {
    const options = action.payload;
    state.auditorViewFilters.auditorViewFilterOptionsLoading= false;
    state.auditorViewFilters.auditorViewFiltersPriority = options?.priority || [];
    state.auditorViewFilters.auditorViewFiltersStatus = options?.status || [];
  }).addCase(getauditorViewFilterOptions.rejected, (state, action) => {
    state.auditorViewFilters.auditorViewFilterOptionsLoading = false;
    state.auditorViewFilters.auditorViewFilterOptionsError = action.payload;
  })
  .addCase(specialityOptions.pending, (state) => {
    state.speciality.specialityLoading = true;
    state.speciality.specialityError = null;
  }).addCase(specialityOptions.fulfilled, (state, action) => {
    state.speciality.specialityLoading= false;
    state.speciality.specialityData = [
      ...state.speciality.specialityData,
      ...action.payload?.specialties || []
    ]
    // const isValidPage = action.payload?.has_more ?? false;
    const isValidPage = action.payload ? action.payload?.has_more : false;
    state.speciality.isSpecialityPageTrue = isValidPage || false;
  }).addCase(specialityOptions.rejected, (state, action) => {
    state.speciality.specialityLoading = false;
    state.speciality.isSpecialityPageTrue = false;
    state.speciality.specialityError = action.payload;
  })
  .addCase(queueOptions.pending, (state) => {
    state.queue.queueLoading = true;
    state.queue.queueError = null;
  }).addCase(queueOptions.fulfilled, (state, action) => {
    state.queue.queueLoading= false;
    state.queue.queueData = [
      ...state.queue.queueData,
      ...action.payload?.queues?.queues || []
    ];
    const isValidPage = action.payload?.queues?.queue_name_still_available ?? false;
    state.queue.isQueuePageTrue = isValidPage || false;
  }).addCase(queueOptions.rejected, (state, action) => {
    state.queue.queueLoading = false;
    state.queue.isQueuePageTrue = false
    state.queue.queueError = action.payload;
  })
   .addCase(getAllQueuesData.pending, (state) => {
    state.getQueuesData.queuesLoading = true;
    state.getQueuesData.queuesError = null;
  }).addCase(getAllQueuesData.fulfilled, (state,action) => {
    state.getQueuesData.queuesLoading= false;
    state.getQueuesData.queuesData = action.payload;
  }).addCase(getAllQueuesData.rejected, (state, action) => {
    state.getQueuesData.queuesLoading = false;
    state.getQueuesData.queuesError = action.payload;
  })
  .addCase(URnumberOptions.pending, (state) => {
    state.episodesURnumber.episodesURnumberLoading = true;
    state.episodesURnumber.episodesURnumberError = null;
  }).addCase(URnumberOptions.fulfilled, (state, action) => {
    state.episodesURnumber.episodesURnumberLoading= false;
    // state.users.usersData = action.payload;
    state.episodesURnumber.episodesURnumberData = [
      ...state.episodesURnumber.episodesURnumberData,
      ...action.payload?.episodes_with_ur_number || []
    ];
    const isValidPage = action.payload?.has_more ?? false;
    state.episodesURnumber.isEpisodesURnumberPageTrue = isValidPage || false;
  }).addCase(URnumberOptions.rejected, (state, action) => {
    state.episodesURnumber.episodesURnumberLoading = false;
    state.episodesURnumber.episodesURnumberError = false;
     state.episodesURnumber.episodesURnumberError = null;
  })
  .addCase(changeStatus.pending, (state) => {
    state.status.statusChangeLoading = true;
    state.status.statusChangeError = null;
  }).addCase(changeStatus.fulfilled, (state,action) => {
    state.status.statusChangeLoading= false;
    state.status.statusChangeMessage = action.payload;
  }).addCase(changeStatus.rejected, (state, action) => {
    state.status.statusChangeLoading = false;
    state.status.statusChangeError = action.payload;
  })
});

export const { updateFilters, updateSpecialityPageNumber, updateQueuePageNumber, updateUserPageNumber, updateComponentState, updateAuditorPage, updateAuditorPageNumber} = auditorViewSlicer.actions;

export default auditorViewSlicer.reducer;
